// App
import React from 'react';

// Icons
import IconAppleAppStoreBadge from 'images/apple-badge.min.svg';
import IconAndroidPlayStoreBadge from 'images/android-badge.min.svg';

// Misc / utils
import * as S from './styles';

type AppBadgesProps = {
  onBadgeClick?: () => void;
};

const AppBadges = ({ onBadgeClick }: AppBadgesProps) => {
  return (
    <>
      <S.Linker
        to={`/mobile-apps/ios?adgroup=homepageFooter`}
        tabIndex={0}
        onClick={onBadgeClick}
        data-footer-page={'iosApp'}
        target="_blank"
        rel="nofollow"
        escape
      >
        <S.BadgeImg
          loading="lazy"
          src={IconAppleAppStoreBadge}
          alt="Apple app store badge"
          width="120px"
          height="35px"
        />
      </S.Linker>
      <S.Linker
        to={`/mobile-apps/android?adgroup=homepageFooter`}
        tabIndex={0}
        onClick={onBadgeClick}
        data-footer-page={'androidApp'}
        target="_blank"
        rel="nofollow"
        escape
      >
        <S.BadgeImg
          loading="lazy"
          src={IconAndroidPlayStoreBadge}
          alt="Android play store badge"
          width="120px"
          height="35px"
        />
      </S.Linker>
    </>
  );
};

export default AppBadges;
